import { Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DefaultSwitche } from "../../../../Constant";
import { DEFAULT_SWITCH, DEFAULT_SWITCH_LIST } from "../../../../Data/FormControl/CheckboxAndRadio";
import { H6 } from "../../../../AbstractElements";
import { CustomSwitche } from "./CustomSwitche";

const DefaultSwitches = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={DefaultSwitche} span={DEFAULT_SWITCH} />
        <CardBody>
          <Row className="g-3">
            <CustomSwitche/>
            {DEFAULT_SWITCH_LIST.map(({ title, span, className, inputClass }, index) => (
              <Col md="6" xl="4" key={index}>
                <div className="card-wrapper border rounded-3 rtl-input checkbox-checked">
                  <H6 className="sub-title">{title}</H6>
                  {span.map(({ id, label, defaultChecked, disabled }, index) => (
                    <div className={`form-check form-switch ${className}`} key={index}>
                      <Input id={id} type="switch" className={inputClass} role="switch" defaultChecked={defaultChecked} disabled={disabled} />
                      <Label htmlFor={id} check>{label}</Label>
                    </div>
                  ))}
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DefaultSwitches;
